import React, { createContext, useState, useContext, useMemo } from 'react';

const ChatbotContext = createContext();

export const ChatbotProvider = ({ children }) => {
  const [communitySlug, setCommunitySlug] = useState(undefined);

  // Use useMemo to prevent unnecessary re-renders of consumers 
  // when the provider itself re-renders but the context value hasn't changed.
  const value = useMemo(() => ({
    communitySlug,
    setCommunitySlug,
  }), [communitySlug]);

  return (
    <ChatbotContext.Provider value={value}>
      {children}
    </ChatbotContext.Provider>
  );
};

// Custom hook to use the Chatbot context
export const useChatbotContext = () => {
  const context = useContext(ChatbotContext);
  if (context === undefined) {
    throw new Error('useChatbotContext must be used within a ChatbotProvider');
  }
  return context;
}; 